<template>
	<mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
	<div class="evaluate-wrap" v-else>
		<div class="evaluate-label" v-if="GoodsComm.favRate">
			<p class="head">好评度<span >{{GoodsComm.favRate}}%</span></p>
			<span class="label" v-for="tag in GoodsComm.commentTags">{{tag.name}}</span>
		</div>
		<div class="evaluate-detail">
			<empty  emptytext="对不起，暂时没有找到结果" v-if="GoodsCommList.length<1"></empty>
			<div class="evaluate-item" v-for="item in GoodsCommList">
				<div class="user-info">
					<span class="head">
						<imgs :imagePath="item.header && item.header.imagePath"></imgs>
					</span>
					<div class="content">
						<p class="name">{{item.memName}}</p>
						<p class="time">
							<span class="floatL">{{item.commTime}}</span>
							<div class="floatR">
								<span class="star" v-for="i in 5" :class="{active:i <= Math.floor(item.starScore)}"></span>
							</div>
							<div class="clearfix"></div>
						</p>
					</div>
				</div>
				<div class="evaluate-content">{{item.commDesc}}</div>
				<div class="merchant-reply" v-if="item.replyDesc">
					<div class="header">
						<span class="floatL">美心商城回复：</span>
						<span class="floatR time">{{item.replyTime}}</span>
						<div class="clearfix"></div>
					</div>
					<div class="evaluate-content">{{item.replyDesc}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import imgs from '@components/image/image';
	import {mapActions,mapGetters} from 'vuex';
	import empty from '@components/empty/empty';
	export default{
		data(){
			return{
				load:true,
				GoodsComm:{},
				GoodsCommList:{},
				goodsId:this.$route.query.goodsId,//商品id
				pageNo: 1,
			    pageSize: 10,
			    total: 0,
			}
		},
		methods:{
            ...mapActions({
                pageGoodsCommMsg:'pageGoodsCommMsg',
                getGoodsCommMsg:'getGoodsCommMsg'
            }),
            //11.7.获取商品评价总览
            getGoodsCommtag(){
               this.getGoodsCommMsg([this.goodsId]).then(res=>{
					this.GoodsComm = res;
				})
            },
            //11.8.分页查询商品评价
            getGoodsCommContent(){
               this.pageGoodsCommMsg([this.goodsId,this.pageNo,this.pageSize]).then(res=>{
					this.GoodsCommList = res.result;
					this.total = Number(res.totalCount);
					this.load = false
				})
            },
        },
		components:{
			imgs,
    		empty
		},
		created(){
			this.getGoodsCommtag();
			this.getGoodsCommContent();
		}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'src/common/sass/mixin.scss';
	.evaluate-wrap{
		height: 100%;
		background: #fff;
		.evaluate-label{
			height: auto;
			padding: 0 0.1rem 0 0.35rem;
			background: url(/static/images/detail_evaluate_bg_3x.png) no-repeat center;
			background-size: cover;
			color: #fff;
			>.head{
				padding: 0.25rem 0;
				text-align: center;
				line-height: 1;
				@include font-dpr(14px);
				>span{
					@include font-dpr(20px);
					padding-left: 0.125rem;
				}
			}
			>.label{
				display: inline-block;
				padding: 0.15rem 0.2rem;
				line-height: 1;
				margin: 0 0.25rem 0.3rem 0;
				border-radius: 0.5rem;
				background: rgba(255,255,255,.31);
				@include font-dpr(12px);
			}
		}
		.evaluate-detail{
			margin-top: 1px;
			padding: 0.25rem 0.2rem;
			background: #fff;
			.none-conment{
				text-align: center;
    			color: #666;
			}
			.evaluate-item{
				border-bottom: 2px solid #E5E5E5;
				margin: 0.35rem 0 0.5rem 0;
				&:last-child{
					border-bottom: 0;
				}
				.user-info{
					position: relative;
					margin-bottom: 0.3rem;
					.head{
						display: inline-block;
						width: 0.8rem;
						height: 0.8rem;
						border-radius: 50%;
						overflow: hidden;
					}
					.content{
						position: absolute;
						left:1.0rem;
						right: 0;
						top: 0;
						>p{
							@include font-dpr(12px);
							color: #434343;
							&.time{
								color: #B2B2B2;
							}
						}
						.star{
							display: inline-block;
							width: 0.3rem;
							height: 0.3rem;
							margin-left: 0.125rem;
							background: url(/static/images/star_gray_3x.png) no-repeat center;
							background-size: cover;
							&.active{
								background: url(/static/images/star_red_3x.png) no-repeat center;
								background-size: cover;
							}
						}
					}
				}
				.evaluate-content{
					color: #333333;
					line-height: 1.5;
					margin-bottom: 0.25rem;
					text-align: justify;
				}
				.merchant-reply{
					padding: 0.25rem;
					padding-bottom: 1px;
					background: #F0F0F0;
					border-radius: 0.125rem;
					margin-bottom: 0.375rem;
					.header{
						margin-bottom: 0.25rem;
						>span{
							color: #E60012;
							&.time{
								color: #B2B2B2;
							}
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// evaluate.vue?d110f5ec